// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3Ka9Q","imageUploader":"EGiftCard_imageUploader__1AcxO"};